export const TERMINAL_CONNECTION_ERROR_TOAST_KEY = 'terminal-connection-error-toast';
export const TERMINAL_CONNECTION_ERROR_TEXT =
  "Unfortunately, we can't connect you, and you may be unable to admit clients. Please try refreshing. If the issue persists, please contact support via the provider portal.";
export const RETRYING_CONNECTION_INFO_TOAST_KEY = 'retrying-connection-info-toast';
export const RETRYING_CONNECTION_INFO_TEXT =
  'We’re working on connecting you. If the issue persists, please contact support via the provider portal.';
export const SYNC_MAP_ERROR_TOAST_KEY = 'sync-map-error-toast';
export const SYNC_MAP_ERROR_TOAST_TEXT = 'Connection failed. Please refresh to try again.';
